// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { Container, Stack, Typography } from '@mui/material';
import { PropsWithChildren, ReactNode } from 'react';

interface Props {
  /**
   * A page title, rendered above the page content.
   */
  title: ReactNode;

  /**
   * If provided, additional actions are rendered to the right of the title.
   */
  actions?: ReactNode;
}

/**
 * A page layout that renders a title and page content.
 */
export function PageLayout(props: PropsWithChildren<Props>) {
  return (
    <Stack flex={1} overflow="auto">
      <Container maxWidth="xl">
        <Stack
          useFlexGap
          direction="row"
          spacing={{ xs: 1, sm: 3 }}
          paddingX={{ xs: 0, sm: 3 }}
          paddingTop={{ xs: 2, sm: 3 }}
          alignItems="center"
        >
          <Typography
            component="div"
            display="flex"
            variant="h5"
            marginRight="auto"
          >
            {props.title}
          </Typography>
          <Stack spacing={1} marginLeft="auto">
            {props.actions}
          </Stack>
        </Stack>
      </Container>
      {props.children}
    </Stack>
  );
}
